import React from "react";
import "../App.css";
import About from "./About";
import "./Account.css";
import "../AddAndViewConnections.css";
import Follower from "./Follower";
import ProfileStoryList from "./profileStoriesTab/profilePosingList.jsx"

export default class Account extends React.Component {
  constructor(props) {
    super(props);
    console.log(props.userid, sessionStorage.getItem("user"))
    this.state = {
        userId: props.userid,
        username: "",
        pfp:"",
        about: "",
        activeTab: '',
        ownProfile: props.userid === sessionStorage.getItem("user"),
        following: [],
        followCheck: false,
        blockCheck: false,
        connectionID: -1,
        blockCheck: false
    };
    this.fieldChangeHandler.bind(this);
  }
 
  fieldChangeHandler(field, e) {
    console.log("field change");
    this.setState({
      [field]: e.target.value
    });
  }
 
  componentDidMount() {
    console.log("Look here Michael ------------------>", sessionStorage.getItem("token"))
    console.log("In profile");
    console.log(this.props);
    fetch(process.env.REACT_APP_API_PATH+"/users/"+this.state.userId, {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(
        result => {
          if (result) {
            console.log(result);
            if (result.attributes){
            this.setState({
              username: result.attributes.username || "",
              about: result.attributes.about || "",
              pfp: result.attributes.pfp || "",
              activeTab: "about"
            });
          }
          }
        },
        error => {
          console.log("error!");
        }
      );

      fetch(process.env.REACT_APP_API_PATH+"/connections?fromUserID="+this.state.userId, {
        method: "get",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+sessionStorage.getItem("token")
        }
       })
        .then(res => res.json())
        .then(
            result => {
              if (result) {
                let names = [];

    
                result[0].forEach(element => {if (element.attributes.type === 'friend'){names.push(element)}});
 
                this.setState({
                  following: names
                });
                console.log(this.state.following,"here",this.state.userId)
              }
            });
            fetch(process.env.REACT_APP_API_PATH+"/connections?fromUserID="+sessionStorage.getItem("user")+"&toUserID="+this.state.userId, {
              method: "get",
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+sessionStorage.getItem("token")
              }
             })
              .then(res => res.json())
              .then(
                  result => {
                    if (result) {
                      let names = [];

                      result[0].forEach(element => {if (element.toUser.attributes.username){names.push(element)}});
                      console.log('names dot ', names.length);
                      if(names.length>0){
                        console.log("names has elements");
                        this.setState({
                          followCheck: names[0].attributes.type === 'friend',
                          blockCheck: names[0].attributes.type === 'blocking',
                          connectionID: names[0].id
                        });
                      }
                      if(this.state.ownProfile){
                        this.setState({followCheck: false});
                      }
                      console.log("names",names)
                      console.log("hi",this.state.followCheck)
                      console.log("Conn:",this.state.connectionID)
                    }
                  });

                  
                  fetch(process.env.REACT_APP_API_PATH+"/post-reactions="+this.state.userId, {
                    method: "get",
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer '+sessionStorage.getItem("token")
                    }
                   })
                    .then(res => res.json())
                    .then(
                        result => {
                          if (result) {
                            let getInfo = [];
               
                            console.log(result);
           
                            // userId <- element.fromUser.userId # This is something to note!
                            // username <- element.fromUser.attributes.username # This is something to note!
                            result[0].forEach(element => {if (element.attributes.type === 'friend'){getInfo.push({postId: element.postID, reactorID: element.reactorID})}});
               
           
                            this.setState({
                              storyInfo: getInfo
                            });
                            console.log(this.state.follower,"here",this.state.userId)
                          }
                        });
 
                  fetch(process.env.REACT_APP_API_PATH+"/connections?toUserID="+this.state.userId, {
                    method: "get",
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer '+sessionStorage.getItem("token")
                    }
                   })
                    .then(res => res.json())
                    .then(
                        result => {
                          if (result) {
                            let getInfo = [];
               
                            console.log(result);
           
                            // userId <- element.fromUser.userId # This is something to note!
                            // username <- element.fromUser.attributes.username # This is something to note!
                            result[0].forEach(element => {if (element.attributes.type === 'friend'){getInfo.push({username: element.fromUser.attributes.username, userId: element.fromUser.id, user_pic: element.fromUser.attributes.pfp})}});
               
           
                            this.setState({
                              follower: getInfo
                            });
                            console.log(this.state.follower,"here",this.state.userId)
                          }
                        });
  }
  submitHandler = event => {
    event.preventDefault();
    const apiType = this.state.connectionID !== -1 ? 'PATCH' : 'POST'
    fetch(process.env.REACT_APP_API_PATH+"/connections/" + (apiType === 'PATCH' ? this.state.connectionID : ''), {
        method: apiType,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
        },
        body: JSON.stringify({
            toUserID: this.state.userId,
            fromUserID: sessionStorage.getItem("user"),
            attributes:{type:"friend", status:"active"}
        })
    })
    .then(res => res.json())
    .then(response => {
      this.setState({
        followCheck: true,
        blockCheck: false,
        connectionID: response.id
      })
      window.location.reload();
    })
}
submitHandler2 = event => {
  event.preventDefault();
  fetch(process.env.REACT_APP_API_PATH+"/connections/"+this.state.connectionID, {
      method: "DELETE",
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+sessionStorage.getItem("token")
      }
  })
  .then(_ => {
    this.setState({
      followCheck: false,
      connectionID: -1
    });
    window.location.reload();
  })
}

// ----------------------- block/unblock event -----------------------
submitHandlerBlock = event => {
  event.preventDefault();
  const apiType = this.state.connectionID !== -1 ? 'PATCH' : 'POST'

  fetch(process.env.REACT_APP_API_PATH+"/connections/"+ (apiType === 'PATCH' ? this.state.connectionID : ''), {
    method: apiType,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
    },
    body: JSON.stringify({
        toUserID: this.state.userId,
        fromUserID: sessionStorage.getItem("user"),
        attributes:{type:"blocking", status:"active"}
    })
  })
  .then(res => res.json())
  .then(response => {
    this.setState({
      blockCheck: true,
      followCheck: false,
      connectionID: response.id
    });
    window.location.reload();
  })
}
submitHandlerUnblock = event => {
  event.preventDefault();
  fetch(process.env.REACT_APP_API_PATH+"/connections/"+this.state.connectionID, {
    method: "DELETE",
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
    }
  })
  .then( _ => {
    this.setState({
      blockCheck: false,
      connectionID: -1
    })
    window.location.reload();
  })
}
// -------------------------------------------------------------------

  render() {
    return (
        <div className="account">
            <div className={"accountHeader" + (!this.state.ownProfile ? " otherUser" : '')}>
                <div className="accountCreds">
                  <img src={this.state.pfp} alt={this.state.username} className="user_pic_header"/>
                  <h1>{this.state.username}</h1>
                </div>
                {(!this.state.ownProfile && this.state.userId!=113) ? <div className="accountButtons">
                {this.state.followCheck ? 
                  <div className = "fol">
                    <form onSubmit={this.submitHandler2} className="RemFollow">
                      <input type="submit" value="     Unfollow     " />
                    </form>
                  </div> 
                : !this.state.ownProfile ? 
                  <div className = "fol">
                    <form onSubmit={this.submitHandler} className="AddFollow" >
                      <input type="submit" value="      Follow      " />
                    </form>
                  </div>
                : 
                  '' 
                }

          {/* ----------------------- block/unblock button ----------------------- */}
          {!this.state.blockCheck && !this.state.ownProfile ?
          <div className = "blockButton">
            <form onSubmit={this.submitHandlerBlock} className="AddBlock">
              <input type="submit" value="Block"/>
            </form>
          </div>
           : this.state.blockCheck && !this.state.ownProfile ?
          <div className = "blockButton">
            <form onSubmit={this.submitHandlerUnblock} className="DelBlock">
              <input type="submit" value="Unblock"/>
            </form>
          </div> : ''} </div> : '' }
          {/* --------------------------------------------------------------------- */}

            </div>
            <div className="accountTabs">
                <button onClick={e => this.fieldChangeHandler('activeTab', e)} className={this.state.activeTab === 'about' ? 'buttonActive' : 'buttonInactive'} value='about' >About</button>
                <button onClick={e => this.fieldChangeHandler('activeTab', e)} className={this.state.activeTab === 'stories' ? 'buttonActive' : 'buttonInactive'} value='stories'>Stories</button>
                <button onClick={e => this.fieldChangeHandler('activeTab', e)} className={this.state.activeTab === 'following' ? 'buttonActive' : 'buttonInactive'} value='following'>Following</button>
                <button onClick={e => this.fieldChangeHandler('activeTab', e)} className={this.state.activeTab === 'follower' ? 'buttonActive' : 'buttonInactive'} value='follower'>Follower</button>
            </div>
            <div className="accountBody">
                {this.state.activeTab === 'about' ? <About about={this.state.about}/> : this.state.activeTab === 'following' ? <div className = "following">
                    {this.state.following.map((friend)=>{return(<div className = "accountBox" key = {friend.toUserID}><br/><a href = {"./"+friend.toUserID}><img height = "100" width = "100" className = "user_pic" src={friend.toUser.attributes.pfp} /*Reminder to change this to url of profile pic when that is situated*/alt = {friend.toUser.attributes.username}/></a><br/>{friend.toUser.attributes.username}</div>)})}
                </div> : this.state.activeTab === 'follower' ? <div className="following"><Follower followerList={this.state.follower}/> </div> : this.state.activeTab === 'stories' ? <ProfileStoryList followerList={this.state.storyInfo} userId={this.state.userId}/> : ''}
            </div>
        </div>
    );
  }
}
